import { Control, Controller, FieldValues, Path } from 'react-hook-form';

import { SelectCountryV2 } from '@/shared/components/forms/fields/SelectCountryV2';
import { Option } from '@/shared/uikitV2/Select/types';

type SelectFromListProps<TFieldValues extends FieldValues> = {
  control: Control<TFieldValues, unknown>;
  name: Path<TFieldValues>;
  options?: Option[];
  label: string;
  required?: boolean | string;
  disabled?: boolean;
  isMultiple?: boolean;
  withSearch?: boolean;
};

export const SelectFromList = <TFieldValues extends FieldValues = FieldValues>({
  control,
  name,
  options,
  label,
  required,
  disabled,
  isMultiple,
  withSearch,
}: SelectFromListProps<TFieldValues>) => {
  if (!options) return null;

  return (
    <Controller
      name={name}
      control={control}
      rules={{ required }}
      render={({ field, fieldState }) => {
        return (
          <SelectCountryV2
            multiple={Boolean(isMultiple)}
            name={field.name}
            onChange={field.onChange}
            status={fieldState.error ? 'error' : 'default'}
            errorText={fieldState.error?.message}
            options={options}
            label={label}
            required={Boolean(required)}
            disabled={disabled}
            value={field.value}
            withSearch={withSearch}
          />
        );
      }}
    />
  );
};
